const CARDS = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20dramatic%20lighting%2C%20film%20poster%20aesthetic%2C%20warm%20orange%20and%20amber%20tones%2C%20Chinese%20film%20atmosphere%2C%20cinematic%20photography%20style%2C%20movie%20theater%20mood%2C%20professional%20cinema%20lighting%2C%20film%20grain%20texture%2C%20elegant%20composition&width=800&height=500&seq=card-01&orientation=landscape',
    tag: '热播推荐',
    title: '2024年度必看国产剧精选合集',
    desc: '精选年度口碑最佳国产电视剧，部部精彩不容错过。从古装权谋到都市情感，白云视频为您一网打尽。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20dynamic%20composition%2C%20film%20poster%20style%2C%20warm%20golden%20tones%2C%20intense%20atmosphere%2C%20cinematic%20photography%2C%20dramatic%20lighting%2C%20professional%20movie%20aesthetic%2C%20film%20atmosphere&width=800&height=500&seq=card-02&orientation=landscape',
    tag: '动作大片',
    title: '好莱坞动作巨制一站畅享',
    desc: '从经典到最新，收录数百部高分动作大片。肾上腺素飙升的观影体验，高清画质让每个爆炸场面都震撼人心。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20scene%20with%20vibrant%20colors%2C%20Japanese%20animation%20style%2C%20warm%20atmosphere%2C%20cinematic%20composition%2C%20beautiful%20background%20art%2C%20professional%20anime%20aesthetic%2C%20film%20poster%20quality&width=800&height=500&seq=card-03&orientation=landscape',
    tag: '动漫专区',
    title: '人气动漫番剧每日同步更新',
    desc: '日漫、国漫热门番剧全覆盖，紧跟日本播出进度。白云视频动漫频道，二次元爱好者的免费观影天堂。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20soft%20lighting%2C%20film%20poster%20aesthetic%2C%20warm%20peach%20and%20amber%20tones%2C%20cinematic%20photography%2C%20emotional%20atmosphere%2C%20elegant%20composition%2C%20professional%20drama%20mood&width=800&height=500&seq=card-04&orientation=landscape',
    tag: '韩剧热播',
    title: '高分韩剧合集：浪漫与悬疑',
    desc: '从甜蜜爱情到烧脑悬疑，精选豆瓣高分韩剧合集。白云视频带您领略韩剧的独特魅力，每部都是口碑之选。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20studio%20scene%20with%20colorful%20lighting%2C%20entertainment%20program%20aesthetic%2C%20warm%20atmosphere%2C%20professional%20TV%20production%20style%2C%20cinematic%20photography%2C%20vibrant%20composition%2C%20show%20stage%20mood&width=800&height=500&seq=card-05&orientation=landscape',
    tag: '综艺精选',
    title: '热门综艺节目随时随地观看',
    desc: '搞笑、音乐、竞技、真人秀，各类热门综艺应有尽有。白云视频综艺频道，让笑声与感动常伴左右。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          编辑精选
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          精心策划的影视专题，发现更多好内容
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.slice(0, 2).map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    {c.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {c.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </div>
          ))}
          {CARDS.slice(2).map((c, i) => (
            <div
              key={i + 2}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 group cursor-pointer md:col-span-2 lg:col-span-1"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {c.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2">
                  {c.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}